module.exports = __webpack_public_path__ + "static/media/source.6a096923.gif";